import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { API_BASE_URL } from './../components/config';
import logoPreo from './../img/logoPreto.png';
import logoColorido from './../img/logoColorido.png';
import logoBranco from './../img/logo.png'
import logoBrancoFavicon from './../img/FaviconPreto.png'
import logoPretoFavicon from './../img/FaviconBranco.png'
import logoPretoColorido from './../img/favicon.png'
import { clearBirthdayFireworksSession } from '../components/child/BirthdayFireworks';
import EditProfileModal from '../components/child/EditProfileModal';

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const navigate = useNavigate();
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [imgError, setImgError] = useState(false);

  const permissoesMenu = {
    "gestao": [1, 2, 3],   // Somente tipos 1, 2 e 3 podem ver
    "direcao": [1, 2],     // Somente tipos 1 e 2 podem ver
    "secretaria": [3],     // Somente tipo 3 pode ver
    "professor": [4],      // Somente tipo 4 pode ver
    "aluno": [5],          // Somente tipo 5 pode ver
    "admin": [1],          // Somente tipo 1 pode ver
  };

  const userType = parseInt(localStorage.getItem('userType'), 10) || 0;
  const currentUserName = String(localStorage.getItem("userName") || "");
  const isIvanGestor = userType === 1 && currentUserName.toLowerCase().includes("ivan");

  // Função para verificar permissão
  const temPermissao = (categoria) => {
    return permissoesMenu[categoria]?.includes(userType);
  };





  useEffect(() => {
    // Function to handle dropdown clicks
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest('.dropdown');

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains('open');

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll('.sidebar-menu .dropdown');
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove('open');
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add('open');
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll('.sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link');

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener('click', handleDropdownClick);
    });

    // Function to open submenu based on current route
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll('.sidebar-menu .dropdown');
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll('.sidebar-submenu li a');
        submenuLinks.forEach((link) => {
          if (link.getAttribute('href') === location.pathname || link.getAttribute('to') === location.pathname) {
            dropdown.classList.add('open');
          }
        });
      });
    };

    // Open the submenu that contains the open route
    openActiveDropdown();



    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', handleDropdownClick);
      });

    };
  }, [location.pathname]);


  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  useEffect(() => {
    setTheme(localStorage.getItem('theme') || 'light');

    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem('theme');
      if (currentTheme !== theme) {
        setTheme(currentTheme);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [theme]);






  const fetchUserInfo = async () => {
    const userId = localStorage.getItem('userId');
    if (!userId) return;

    try {
      const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        const userData = await response.json();
        setUserInfo(userData);
      }
    } catch (error) {
      console.error('Erro ao buscar dados do usuário:', error);
    }
  };

  const handleOpenProfileModal = () => {
    fetchUserInfo();
    setShowEditProfileModal(true);
  };

  const handleOpenSupport = () => {
    navigate('/suporte');
  };

  const handleUserUpdate = (updatedUser) => {
    setUserInfo(updatedUser);
    // Força atualização da interface
    window.location.reload();
  };

  const handleLogout = () => {
    // Limpar o localStorage ao clicar em "Sair"
    localStorage.removeItem('userName');
    localStorage.removeItem('userType');
    localStorage.removeItem('userId');
    localStorage.removeItem('userProfilePhoto');
    localStorage.removeItem('schoolId');
    localStorage.removeItem('turmaID');

    // Limpar a sessão dos fogos de aniversário
    clearBirthdayFireworksSession();

    // Redirecionar para a página inicial ("/")
    console.log("Chegou no sair")
    navigate('/');
  };

  const getProfileImage = () => {
    const photo = localStorage.getItem("userProfilePhoto");
    if (!photo || photo === "null" || photo === "undefined") {
      return "assets/images/user.png";
    }
    // Se já for URL completa
    if (photo.startsWith("http://") || photo.startsWith("https://")) {
      return photo;
    }
    // Remove barra inicial duplicada se houver e corrige barras invertidas
    const cleanPhoto = photo.replace(/\\/g, '/').replace(/^\/+/, '');
    return `${API_BASE_URL}/${cleanPhoto}`;
  };

  const hasProfilePhoto = () => {
    const photo = localStorage.getItem("userProfilePhoto");
    return photo && photo !== "null" && photo !== "undefined";
  };

  const getInitials = () => {
    const name = localStorage.getItem("userName") || "Usuário";
    const names = name.trim().split(" ");
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials.substring(0, 2);
  };

  const getAvatarColor = (name) => {
    const colors = ['#0d6efd', '#198754', '#0dcaf0', '#ffc107', '#dc3545', '#6610f2', '#fd7e14', '#20c997'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
  };


  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>

      <aside className={sidebarActive ? "sidebar active " : mobileMenu ? "sidebar sidebar-open" : "sidebar"}>
        <button onClick={mobileMenuControl} type="button" className="sidebar-close-btn">
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/home" className="sidebar-logo">
            <img
              src={logoColorido}
              alt="site logo"
              className="light-logo"
            />
            <img
              src={logoBranco}
              alt="site logo"
              className="dark-logo"
            />


            <img
              src={theme === 'dark' ? logoBrancoFavicon : logoPretoColorido}
              alt="site logo"
              className="logo-icon"
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <li>
              <NavLink to="/home" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
                <span>Home</span>
              </NavLink>
            </li>

            {temPermissao("gestao") && (
              <li className="dropdown">
                <Link to="#">
                  <Icon icon="heroicons:document" className="menu-icon" />
                  <span>Cadastros</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li>
                    <NavLink to="/cadastro-usuario" className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                      <i className="ri-circle-fill circle-icon text-primary-600 w-auto" /> Cadastro de Usuário
                    </NavLink>
                  </li>
                  {temPermissao("direcao") && (
                    <li>
                      <NavLink to="/cadastro-escola" className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }>
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" /> Cadastro de Escola
                      </NavLink>
                    </li>
                  )}
                  <li>
                    <NavLink to="/cadastro-turma" className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                      <i className="ri-circle-fill circle-icon text-success-main w-auto" /> Cadastro de Turma
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/cadastro-matricula" className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                      <i className="ri-circle-fill circle-icon text-danger-main w-auto" /> Cadastro de Matrícula
                    </NavLink>
                  </li>
                  {temPermissao("direcao") && (
                    <li>
                      <NavLink to="/cadastro-audio" className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }>
                        <i className="ri-circle-fill circle-icon text-info w-auto" /> Cadastro de Áudio
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}

            <li className="sidebar-menu-group-title">Gestão</li>
            <li className="dropdown">
              <Link to="#">
                <Icon icon="solar:document-text-outline" className="menu-icon" />
                <span>Controle Educacional</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  {temPermissao("gestao") && (
                    <NavLink to="/usuarios" className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                      <i className="ri-circle-fill circle-icon text-info w-auto" /> Usuários
                    </NavLink>
                  )}
                </li>
                <li>
                  {temPermissao("gestao") && (
                    <NavLink to="/matriculas" className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                      <i className="ri-circle-fill circle-icon text-danger-main w-auto" /> Matrículas
                    </NavLink>
                  )}
                </li>
                <li>
                  <NavLink to="/turmas" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <i className="ri-circle-fill circle-icon text-success-main w-auto" /> Turmas
                  </NavLink>
                </li>
                <li>
                  {temPermissao("direcao") && (
                    <NavLink to="/escolas" className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                      <i className="ri-circle-fill circle-icon text-orange w-auto" /> Escolas
                    </NavLink>
                  )}
                </li>
              </ul>
            </li>
            {(temPermissao("gestao") || temPermissao("aluno")) && (
              <li>
                <NavLink to="/financeiro" className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                  <Icon icon="hugeicons:money-send-square" className="menu-icon" />
                  <span>Financeiro</span>
                </NavLink>
              </li>
            )}
            {temPermissao("admin") && isIvanGestor && (
              <li>
                <NavLink to="/financeiro2" className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                  <Icon icon="solar:card-transfer-bold" className="menu-icon" />
                  <span>Financeiro 2.0 (BETA)</span>
                </NavLink>
              </li>
            )}
            {temPermissao("admin") && (
              <li>
                <NavLink to="/certificados" className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                  <Icon icon="ph:certificate" className="menu-icon" />
                  <span>Certificados</span>
                </NavLink>
              </li>
            )}
            {temPermissao("admin") && (
              <li>
                <NavLink to="/relatorios" className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                  <Icon icon="solar:chart-square-outline" className="menu-icon" />
                  <span>Relatórios</span>
                </NavLink>
              </li>
            )} 
            {(temPermissao("gestao") || temPermissao("professor")) && (
              <li className="sidebar-menu-group-title">Material</li>
            )}
           {(temPermissao("gestao") || temPermissao("professor")) && (
              <li>
                <NavLink to="/audios" className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                  <Icon icon="ph:music-note-simple" className="menu-icon" />

                  <span> Áudios</span>
                </NavLink>
              </li>
            )}
              {(temPermissao("direcao") || temPermissao("professor")) && (
              <>
                <li>
                  <NavLink to="/treinamento" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <Icon icon="ph:chalkboard-teacher" className="menu-icon" />

                    <span> Treinamento</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/material-extra" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <Icon icon="ph:books" className="menu-icon" />
                    <span> Material Extra</span>
                  </NavLink>
                </li>
              </>
            )}

            {temPermissao("professor") || temPermissao("aluno") ? (
              <>
                <li className="sidebar-menu-group-title">Aula</li>
                <li>
                  <NavLink
                    to={localStorage.getItem("userType") === "5" ? "/sala-de-aula-aluno" : "/sala-de-aula"}
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon="ph:chalkboard-teacher" className="menu-icon" />
                    <span>Sala de Aula</span>
                  </NavLink>
                </li>
              </>
            ) : null}

            {(temPermissao("direcao") || temPermissao("professor") || temPermissao("aluno") || temPermissao("admin")) && (
              <li>
                <NavLink to="/agenda" className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }>
                  <Icon icon="solar:calendar-outline" className="menu-icon" />
                  <span>Agenda</span>
                </NavLink>
              </li>
            )}


          </ul>
        </div>
      </aside>



      <main className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button type="button" className="sidebar-toggle" onClick={sidebarControl}>
                  {
                    sidebarActive ? (<Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />) : (<Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />)
                  }
                </button>
                <button onClick={mobileMenuControl} type="button" className="sidebar-mobile-toggle">
                  <Icon
                    icon="heroicons:bars-3-solid"
                    className="icon"
                  />
                </button>

              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">

                <ThemeToggleButton />

                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    {hasProfilePhoto() && !imgError ? (
                      <img
                        src={getProfileImage()}
                        onError={(e) => {
                          e.target.onerror = null;
                          setImgError(true);
                        }}
                        alt="image_user"
                        className="w-40-px h-40-px object-fit-cover rounded-circle"
                      />
                    ) : (
                      <div 
                        className="w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle text-white fw-bold shadow-sm"
                        style={{ 
                          backgroundColor: getAvatarColor(localStorage.getItem("userName") || "U"), 
                          fontSize: '16px',
                          border: '2px solid #fff'
                        }}
                      >
                        {getInitials()}
                      </div>
                    )}
                  </button>
                  <div style={{zIndex:"99!important"}} className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          {localStorage.getItem("userName") || "Usuário"}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          {(() => {
                            const userType = localStorage.getItem("userType");
                            switch (userType) {
                              case "1":
                                return "Gestor";
                              case "2":
                                return "Diretor";
                              case "3":
                                return "Secretário(a)";
                              case "4":
                                return "Professor";
                              case "5":
                                return "Aluno";
                              default:
                                return "Desconhecido";
                            }
                          })()}
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon icon="radix-icons:cross-1" className="icon text-xl" />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      <li>
                        <button
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          onClick={handleOpenProfileModal}
                          style={{ border: 'none', background: 'none', width: '100%' }}
                        >
                          <Icon icon="solar:user-linear" className="icon text-xl" /> Meu Perfil
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          onClick={handleOpenSupport}
                          style={{ border: 'none', background: 'none', width: '100%' }}
                        >
                          <Icon icon="mdi:lifebuoy" className="icon text-xl" /> Suporte
                        </button>
                      </li>
                      {/* Caixa de Entrada e Configuracoes ocultos conforme solicitado */}
                      <li>
                        <button
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          onClick={handleLogout}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" /> Sair
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>



              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-main-body">{children}</div>


        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© 2025 CIPEX. Todos os direitos reservados.</p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Desenvolvido por <span className="text-primary-600">Vision</span>
              </p>
            </div>
          </div>
        </footer>
      </main>

      {/* Modal de Edição de Perfil */}
      <EditProfileModal
        show={showEditProfileModal}
        onHide={() => setShowEditProfileModal(false)}
        userInfo={userInfo}
        onUserUpdate={handleUserUpdate}
      />
    </section>
  );
};

export default MasterLayout;

